import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AnnouncementModel } from '../dto/announcement.model';

export interface AnnouncementState {
    announcement?: AnnouncementModel[]
    selectedAnnouncement : AnnouncementModel

}

export function createInitialState(): AnnouncementState {
    return {
        announcement: undefined,
        selectedAnnouncement : new AnnouncementModel()
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'announcement', resettable: true })
export class AnnouncementStore extends Store<AnnouncementState> {

    constructor() {
        super(createInitialState());
    }

}